"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ArrowRightIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "15",
  height: "13",
  viewBox: "0 0 15 13",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M10.222 7.658H1.187C.532 7.658 0 7.088 0 6.384c0-.653.458-1.191 1.049-1.264l.138-.009h9.021L7.547 2.18A1.344 1.344 0 0 1 7.47.498l.1-.119A1.129 1.129 0 0 1 9.139.297l.111.107 4.664 5.14c.419.462.446 1.179.083 1.673l-.099.119-4.75 5.045a1.132 1.132 0 0 1-1.679-.008 1.343 1.343 0 0 1-.092-1.681l.1-.12 2.745-2.914Z",
    fill: color
  })]
});

ArrowRightIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ArrowRightIcon;
exports.default = _default;